import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import AppHeader from "../../Comp/AppHeader";
import zx from "./assets/zx.png";

export default function ZXFileManager() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>ZX File Manager | Privacy Policy</title>
      </Helmet>
      <AppHeader name="privacy" indexSlide={0} />
      <nav className="flex flex-col items-center md:flex-row md:justify-center gap-3 pt-20">
        <img
          src={zx}
          alt="ZX File Manager"
          className="w-20 h-20 md:w-30 md:h-30"
        />
        <h1 className="mt-2 md:mt-5 font-bold text-3xl md:text-4xl text-gray-800 text-center">
          ZX File Manager
        </h1>
      </nav>
      <main>
        <div className="w-5/6 md:w-3/4 px-1 break-words md:px-0 m-auto text-gray-700 text-xl">
          <h1 className="mt-20 font-bold text-5xl text-gray-800">
            Privacy Policy
          </h1>
          <p className="mt-4 text-gray-500 text-base">Last Updated: July 16, 2026</p>

          <p className="mt-6">
            ZX File Manager is a file management app developed by Photo Editor &amp; Video Editor - Merger IO, operated under AppSpace Solutions. We respect and protect users’ personal privacy. Please carefully read this Privacy Policy before using our products and services.
          </p>
          <p className="mt-4">
            This privacy policy page informs you of our policies regarding collecting, using, and disclosing personal data when you use our Products or Services and the choices you have associated with that data. By using the Service, you agree to the collection and use of information under this policy.
          </p>

          {/* Table of Contents */}
          <div className="mt-10 bg-gray-50 border border-gray-200 rounded-xl p-6">
            <h2 className="font-bold text-2xl text-gray-800 mb-4">Overview of Privacy Policy</h2>
            <ol className="list-decimal list-inside space-y-2 text-blue-600 text-base">
              <li><a href="#section-1" className="hover:underline">Definitions</a></li>

              <li>
                <a href="#section-2" className="hover:underline">How We Collect and Use Your Personal Information</a>
                <ol className="list-disc list-inside ml-6 mt-1 space-y-1 text-blue-500 text-sm">
                  <li><a href="#section-2-1" className="hover:underline">Storage Permission (For Android 5.0 – Android 10)</a></li>
                  <li><a href="#section-2-2" className="hover:underline">All Files Access Permission (For Android 11 and Above)</a></li>
                  <li><a href="#section-2-gd" className="hover:underline">Google Drive Permission</a></li>
                  <li><a href="#section-2-3" className="hover:underline">Network / Internet Permission</a></li>
                  <li><a href="#section-2-4" className="hover:underline">Precise Location Data</a></li>
                  <li><a href="#section-2-5" className="hover:underline">Personal Data</a></li>
                  <li><a href="#section-2-6" className="hover:underline">Usage and Tracking Data</a></li>
                  <li><a href="#section-2-7" className="hover:underline">Consumer Support and Follow-up Services</a></li>
                  <li><a href="#section-2-8" className="hover:underline">Notification Permission</a></li>
                  <li><a href="#section-2-qia" className="hover:underline">Query Installed Applications Permission</a></li>
                  <li><a href="#section-2-rbp" className="hover:underline">Read Basic Phone State Permission</a></li>
                  <li><a href="#section-2-9" className="hover:underline">Crash Logs &amp; Diagnostics</a></li>
                </ol>
              </li>

              <li>
                <a href="#section-3" className="hover:underline">Reason to Collect User’s Information</a>
                <ol className="list-disc list-inside ml-6 mt-1 space-y-1 text-blue-500 text-sm">
                  <li><a href="#section-3-gd" className="hover:underline">How We Use Google Drive Connection Data</a></li>
                </ol>
              </li>
              <li><a href="#section-4" className="hover:underline">Share, Transfer and Public disclosure of User’s Personal Information</a></li>
              <li><a href="#section-5" className="hover:underline">Storage and Protection of User’s Personal Information</a></li>
              <li><a href="#section-6" className="hover:underline">Use of Cookies</a></li>
              <li><a href="#section-7" className="hover:underline">Data Protection Officer (DPO)</a></li>
              <li><a href="#section-8" className="hover:underline">Our User’s Rights</a></li>
              <li><a href="#section-9" className="hover:underline">Users of California</a></li>
              <li><a href="#section-10" className="hover:underline">EU Users</a></li>
              <li><a href="#section-11" className="hover:underline">Users of Brazil</a></li>
              <li><a href="#section-12" className="hover:underline">Users of Virginia</a></li>

              <li>
                <a href="#section-13" className="hover:underline">DMCA Copyright Policy</a>
                <ol className="list-decimal list-inside ml-6 mt-1 space-y-1 text-blue-500 text-sm">
                  <li>
                    <a href="#section-13-1" className="hover:underline">Infringement policy</a>
                    <ol className="list-disc list-inside ml-6 mt-1 space-y-1 text-blue-400 text-sm">
                      <li><a href="#section-13-1-1" className="hover:underline">How to Report Infringement</a></li>
                    </ol>
                  </li>
                </ol>
              </li>

              <li><a href="#section-14" className="hover:underline">In-app Advertisements</a></li>
              <li><a href="#section-15" className="hover:underline">In-app Purchases</a></li>
              <li><a href="#section-16" className="hover:underline">Liability Limitation</a></li>
              <li><a href="#section-17" className="hover:underline">Disclaimer of Warranty</a></li>
              <li><a href="#section-18" className="hover:underline">Copyright and Trademarks</a></li>
              <li><a href="#section-19" className="hover:underline">Push Notifications</a></li>
              <li><a href="#section-20" className="hover:underline">Retention of data</a></li>
              <li><a href="#section-21" className="hover:underline">Data Recovery Policy</a></li>
              <li><a href="#section-22" className="hover:underline">Security of data</a></li>
              <li><a href="#section-23" className="hover:underline">Our Policy On “DO NOT TRACK” Signals Under The California Online Protection Act (CALOPPA)</a></li>

              <li>
                <a href="#section-24" className="hover:underline">Service Providers</a>
                <ol className="list-decimal list-inside ml-6 mt-1 space-y-1 text-blue-500 text-sm">
                  <li>
                    <a href="#section-24-1" className="hover:underline">Disclaimer</a>
                    <ol className="list-disc list-inside ml-6 mt-1 space-y-1 text-blue-400 text-sm">
                      <li><a href="#section-24-1-1" className="hover:underline">Analytics</a></li>
                      <li><a href="#section-24-1-2" className="hover:underline">Advertising</a></li>
                      <li><a href="#section-24-1-3" className="hover:underline">Behavioral Remarketing</a></li>
                    </ol>
                  </li>
                </ol>
              </li>

              <li><a href="#section-25" className="hover:underline">Payments</a></li>
              <li><a href="#section-26" className="hover:underline">Links to other sites</a></li>
              <li><a href="#section-27" className="hover:underline">Children’s Privacy</a></li>
              <li><a href="#section-28" className="hover:underline">Privacy Policy Changes</a></li>
              <li><a href="#section-29" className="hover:underline">Contact Us</a></li>
            </ol>
          </div>

          {/* Definitions */}
          <section id="section-1" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Definitions</h2>
            <p className="mb-4">Understand the basics of the privacy policy with the following terms.</p>

            <div className="ml-2 space-y-6">
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Service</h3>
                <p>Service is referred to as games, mobile applications, other products, and websites operated by Photo Editor &amp; Video Editor - Merger IO.</p>
              </div>
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Personal Data</h3>
                <p>Personal Data is any information that can be used to identify any individual, such as name, email address, device identifiers, IP address, location data, or other information associated with a specific user.</p>
              </div>
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Usage Data</h3>
                <p>Usage Data is collected automatically when you use the Service. The information may include device type, time spent in the app, page visits, and more such diagnostic data.</p>
              </div>
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Cookies</h3>
                <p>Cookies are small data files stored on your device that help improve your experience, remember preferences, and analyze how the service is used.</p>
              </div>
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Data Controller</h3>
                <p>Data Controller means the natural or legal person who (either alone or jointly or in common with other persons) decides what personal data is collected and how it will be used. For this Privacy Policy, we are a Data Controller of your Personal Data.</p>
              </div>
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Data Processors (or Service Providers)</h3>
                <p>Data Processor (or Service Provider) means any natural or legal person who processes the data on behalf of the Data Controller. We may use the services of various Service Providers to process your data more effectively.</p>
              </div>
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Data Subject (or User)</h3>
                <p>Data Subject is you, any individual who is using our Service and is the subject of Personal Data.</p>
              </div>
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Data Protection Officer (DPO)</h3>
                <p>A DPO is a designated person who is in charge of managing an organization's or company's data protection policy. It makes sure that data protection rules and laws are followed.</p>
              </div>
            </div>
          </section>

          {/* Section 2 */}
          <section id="section-2" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">
              How We Collect and Use Your Personal Information
            </h2>
            <p className="mb-4">
              ZX File Manager helps users to manage files stored on their devices easily and effectively. We do not collect or store your personal files, such as photos, videos, documents, or any other media content.
            </p>
            <p className="mb-4">We want to provide you core features for which we need the following permissions:</p>

            <div className="ml-2 space-y-6">
              <div id="section-2-1">
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Storage Permission (For Android 5.0 – Android 10)</h3>
                <p>
                  Storage permission is required to access your local device to manage or search files stored on your device. With this permission, you can browse, copy, move, rename, or delete files on your device. The app will not automatically modify or delete any content without your action.
                </p>
              </div>
              <div id="section-2-2">
                <h3 className="font-semibold text-xl text-gray-800 mb-2">All Files Access Permission (For Android 11 and Above)</h3>
                <p className="mb-2">
                  All Files Access permission is required to provide complete file management functionality. This permission allows the app to display and manage files stored on your device so that you can organize and manage them easily.
                </p>
                <p>
                  All file operations on your local device storage are performed locally on your device, and we do not upload or store these files on external servers. The only exception is if you choose to connect a third-party cloud storage account, such as Google Drive; in that case, files are transferred directly between your device and the cloud account you control; we do not have a server that stores or has access to those files. See 'Google Drive Permission' below for details.
                </p>
              </div>

              <div id="section-2-gd">
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Google Drive Permission</h3>
                <p className="mb-2">
                  If you want to manage or access files and folders stored in your Google Drive, we may need permission to access your Google account. Specifically, the app requests two levels of access:
                </p>
                <ul className="list-disc list-inside ml-4 space-y-1 mb-2">
                  <li>Read-only access to your entire Google Drive (file and folder names, types, and structure), so the app can display your full Drive contents for browsing.</li>
                  <li>Full access limited to files you create or open through ZX File Manager (such as files you upload, download, rename, or delete using the app). We cannot create, edit, or delete files elsewhere in the Drive that you have not opened or created through the app.</li>
                </ul>
                <p className="mb-2">
                  The whole authorization process is completed between you and Google directly. ZX File Manager does not see or collect your Google account password, email address, or profile information. After authorization, ZX File Manager only stores your Google account connection information (such as the access token) locally on your device and does not upload it to our servers. Files you transfer move directly between your device and your Google Drive. We do not store copies of these files or their contents. You can remove the connected account at any time from within the app, or by revoking access from your Google Account permissions page (
                  <a href="https://myaccount.google.com/permissions" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    myaccount.google.com/permissions
                  </a>
                  ), or by uninstalling the app.
                </p>
                <p>
                  Our use and transfer of information received from Google APIs adheres to the{" "}
                  <a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    Google API Services User Data Policy
                  </a>
                  , including the Limited Use requirements.
                </p>
              </div>

              <div id="section-2-3">
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Network / Internet Permission</h3>
                <p className="mb-2">Certain features in the app may require internet access, including:</p>
                <ul className="list-disc list-inside ml-4 space-y-1 mb-2">
                  <li>Downloading files or media from publicly accessible links</li>
                  <li>Loading advertisements</li>
                  <li>App updates and analytics</li>
                  <li>Connecting to and syncing files with a cloud storage account you choose to link, such as Google Drive</li>
                </ul>
                <p className="mb-2">
                  Any files you download through the app are saved directly to your device storage, and we do not store these files on our servers.
                </p>
                <p>
                  Users are responsible for ensuring that the content they download complies with the terms and policies of the respective platforms and applicable copyright laws.
                </p>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded">
                <p className="font-semibold text-gray-800 mb-1">Disclaimer:</p>
                <p className="text-base">
                  ZX File Manager is not affiliated with or endorsed by any social media platforms. Users are solely responsible for how they use the downloaded content. Please ensure you have permission from the content owner before downloading or sharing any media.
                </p>
              </div>

              {/* Precise Location Data */}
              <div id="section-2-4">
                <h3 className="font-semibold text-xl text-gray-800 mb-2">
                  Precise Location Data
                </h3>
                <p className="mb-4">
                  Our app collects Precise Location Data through the [ACCESS_FINE_LOCATION] and [ACCESS_MEDIA_LOCATION] permissions. We need this permission to find nearby devices to perform file transfer capabilities (such as using Bluetooth or Wi-Fi Direct). Accurately detecting and connecting to neighboring devices is made easier by precise positioning, particularly when proximity is important for file transmission.
                </p>
              </div>

              {/* Users Can Control or Opt Out */}
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">
                  Users Can Control or Opt Out
                </h3>
                <p className="mb-2">You have control over your location data. You can:</p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>Disable Location Permissions in your device settings.</li>
                  <li>
                    Request Data Deletion by contacting us at{" "}
                    <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600 hover:underline">
                      feedback@appspacesolutions.in
                    </a>
                    .
                  </li>
                </ul>
              </div>

              {/* Personal Data */}
              <div id="section-2-5">
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Personal Data</h3>
                <p className="mb-4">
                  We gather personal information from a variety of sources, including you directly (for example, when you contact us), the information generated by our interactions, and information we get from other sources like public databases, third-party services, and commercial sources (like social media platforms, partners in advertising, and analytics companies). In certain situations, we could be obligated by contract or law to acquire personal data. We might be unable to complete these tasks on time if you do not supply this important information. We will notify you during the data collection process if any information is required and what happens if you don't provide it.
                </p>
                <p className="font-semibold mb-2">
                  CATEGORIES OF SENSITIVE PERSONAL DATA WE MAY COLLECT
                </p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>Personal data (such as age range, gender, monikers, etc.).</li>
                  <li>Contact details (such as phone number and email address).</li>
                  <li>Information for authentication and identification (such as an image, username, or user ID).</li>
                  <li>Transactional data includes details about any requests, questions, or complaints you may have made.</li>
                  <li>The information we automatically gather from you includes information about your use of the internet and other electronic networks, such as the log data, search history, and actions you take within our app; information about your device, such as its version, operating system, language and region settings, and identification number; and information about the other applications you have installed.</li>
                </ul>
              </div>

              {/* Usage and Tracking Data */}
              <div id="section-2-6">
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Usage and Tracking Data</h3>
                <p>
                  Usage Data may include information such as your computer’s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data. It may also include information such as the type of mobile device you use, your mobile device's unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers, usage patterns, and other diagnostic data. We collect non-personal tracking information to help us improve the App and provide better services.
                </p>
              </div>

              {/* Consumer Support */}
              <div id="section-2-7">
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Consumer Support and Follow-up Services</h3>
                <p>
                  When users send their feedback or error reports via email, we obtain your username, email address, and email content. This helps in communicating with you about any problems you face while using our product or service.
                </p>
              </div>

              {/* Notification Permission */}
              <div id="section-2-8">
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Notification Permission</h3>
                <p>
                  For devices with Android 13 and above, with your permission, we may send notifications to inform you of important events, messages, news, or updates related to the casting process. You can turn these notifications on or off at any time in your device settings. We do not use notifications for unsolicited advertising.
                </p>
              </div>

              {/* Query Installed Applications Permission */}
              <div id="section-2-qia">
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Query Installed Applications Permission</h3>
                <p>
                  Our File Manager app uses this permission to display the list of apps installed on your device. We do not collect or share any information about your installed apps.
                </p>
              </div>

              {/* Read Basic Phone State Permission */}
              <div id="section-2-rbp">
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Read Basic Phone State Permission</h3>
                <p className="mb-2">
                  The READ_BASIC_PHONE_STATE permission may appear as used by our ZX File Manager app. This permission is not explicitly requested by our application. It is automatically introduced as a dependency by one or more third-party libraries or SDKs integrated into the app (such as advertising, analytics, or crash-reporting SDKs). This is a normal occurrence in Android development, where underlying libraries may declare permissions independently of the app developer's direct intent.
                </p>
                <p>
                  This permission, at its most basic level, allows read access to non-sensitive device state information (such as whether the device supports telephony). Our app does not actively use this permission for any feature or functionality, nor does it access, collect, or share any phone state data. If you have concerns about this permission, please be assured that its presence is incidental and is governed by the respective third-party library's own privacy practices.
                </p>
              </div>

              {/* Crash Logs */}
              <div id="section-2-9">
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Crash Logs &amp; Diagnostics</h3>
                <p>
                  To improve stability and identify bugs, our app may collect anonymized crash logs and diagnostic reports. These logs do not include personal content (such as photos, videos, or private files) and are used solely for troubleshooting and performance optimization.
                </p>
              </div>
            </div>
          </section>

          {/* Section 3 - Reason to Collect */}
          <section id="section-3" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Reason to Collect User’s Information</h2>
            <p className="mb-2">ZX File Manager uses the collected data for various purposes:</p>
            <ul className="list-disc list-inside ml-4 space-y-1 mb-6">
              <li>To provide and maintain our Service</li>
              <li>To notify you about changes to our Service</li>
              <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
              <li>To provide customer support</li>
              <li>To gather analysis or valuable information so that we can improve our Service</li>
              <li>To monitor the usage of our Service</li>
              <li>To detect, prevent, and address technical issues</li>
              <li>To follow legal guidelines</li>
              <li>To identify and resolve bugs by analyzing crash logs and diagnostic reports.</li>
            </ul>

            <div id="section-3-gd">
              <h3 className="font-semibold text-xl text-gray-800 mb-2">How We Use Google Drive Connection Data</h3>
              <p className="mb-2">The limited information involved in the Google Drive integration is used strictly to:</p>
              <ul className="list-disc list-inside ml-4 space-y-1 mb-4">
                <li>Establish and maintain the connection between the app and your Google account so you can browse your cloud files from within the app.</li>
                <li>Display your file and folder list so you can select what to upload, download, rename, move, or delete.</li>
                <li>Carry out the specific file action you request (e.g., transferring a file from your device to your connected cloud storage, or vice versa).</li>
                <li>Keep you signed in to your connected account for your convenience until you disconnect or your Google session expires.</li>
                <li>Diagnose and fix errors related to the cloud connection (e.g., failed uploads), using anonymized crash/error logs that do not include your file contents.</li>
              </ul>
              <p className="mb-2 font-medium">We do not use this data for:</p>
              <ul className="list-disc list-inside ml-4 space-y-1 mb-4">
                <li>Advertising or ad targeting.</li>
                <li>Building a profile of you or your files.</li>
                <li>Sale or sharing with third parties, other than Google itself (as the cloud provider you chose to connect).</li>
                <li>Any automated decision-making.</li>
              </ul>
              <p className="mb-6">
                We do not retain this data on our servers beyond what is technically necessary to complete the action you requested in that session. Once a file transfer is complete, we do not keep a copy of the file or its contents.
              </p>
            </div>

            <div>
              <h3 className="font-semibold text-xl text-gray-800 mb-2">Use of data</h3>
              <p className="mb-2">The App uses the collected data for various purposes:</p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>To provide and maintain our Service</li>
                <li>To notify you about changes to our Service</li>
                <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
                <li>To provide customer support</li>
                <li>To gather analysis or valuable information so that we can improve our Service</li>
                <li>To monitor the usage of our Service</li>
                <li>To detect, prevent, and address technical issues</li>
              </ul>
            </div>
          </section>

          {/* Section 4 - Share, Transfer, Public Disclosure */}
          <section id="section-4" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">
              Share, Transfer and Public disclosure of User’s Personal Information
            </h2>

            <h3 className="font-semibold text-xl text-gray-800 mb-2">HOW WE SHARE YOUR PERSONAL DATA</h3>
            <p className="mb-2 font-medium">We do not sell your personal data.</p>

            <p className="mb-2">
              However, we may share limited information with third-party service providers to support our app’s functionality, including:
            </p>
            <ul className="list-disc list-inside ml-4 space-y-1 mb-4">
              <li>Analytics providers (to understand app usage and improve performance)</li>
              <li>Advertising partners (to display relevant ads)</li>
              <li>Service providers (such as hosting, crash reporting, or customer support tools)</li>
            </ul>

            <p className="mb-2 font-medium">The types of information that may be shared include:</p>
            <ul className="list-disc list-inside ml-4 space-y-1 mb-4">
              <li>Device information (such as device model, OS version, and unique identifiers)</li>
              <li>Usage data (such as app interactions, features used, and session duration)</li>
              <li>Log and diagnostic data (such as crash logs and performance data)</li>
              <li>Approximate location data (if enabled on your device)</li>
            </ul>

            <p className="mb-4">
              These third parties are authorized to use your information only as necessary to provide services on our behalf and are obligated to protect your data.
            </p>

            <p className="mb-4">
              Depending on your location, you may have specific privacy rights under applicable laws, including the California Consumer Privacy Act (CCPA), the General Data Protection Regulation (GDPR), and other similar data protection regulations. These rights may include the right to access, request deletion, or know how your data is used and shared. These are further explained later in the privacy policy.
            </p>

            <p className="mb-4">
              We only share data as necessary to operate, improve, and monetize our services, and never for unauthorized purposes.
            </p>

            <p className="mb-6">
              You have the right to know whether your personal data is shared and with whom. To request this information, please contact us at{" "}
              <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600 hover:underline">
                feedback@appspacesolutions.in
              </a>
              .
            </p>

            <h3 className="font-semibold text-xl text-gray-800 mb-2">TRANSFER</h3>
            <p className="mb-4">
              We will not disclose your personal information to any company, organization, or individual, except as required by law, administrative enforcement, or regulatory authorities.
            </p>

            <h3 className="font-semibold text-xl text-gray-800 mb-2">PUBLIC DISCLOSURE</h3>
            <p>
              As required by laws, regulations, or legal authorities, we may need to share your personal information with enforcement or regulatory bodies. Any disclosure will be limited to the specific information requested and will follow the prescribed legal procedures.
            </p>
          </section>

          {/* Section 5 - Storage and Protection */}
          <section id="section-5" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">
              Storage and Protection of User’s Personal Information
            </h2>
            <p className="mb-4">
              The App requires access to your device’s media storage to provide seamless functionality, such as browsing, playing, downloading and managing your media files. This access is granted through the <a href="https://developer.android.com/training/data-storage/shared/media" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline"> Media Storage Permission</a> as per Google’s guidelines. By allowing this permission, our app can retrieve and display media files stored on your device, such as videos, music, and any format of media files to enhance your user experience. Rest assured, we only access the necessary media files for the app’s core functions, and we do not collect, store, share, or sell any personal information from your media library even when you are using Google Drive. Since files move directly between the device and your Google account, the transfer of files is encrypted in transit (via HTTPS/TLS). Users retain full control over their files, and data is handled responsibly in compliance with Google's policies to ensure privacy and security.
            </p>
            <p className="mb-2">
              We use Firebase by Google for analytics. You can check its privacy policy for more.
            </p>
            <p>
              Firebase –{" "}
              <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                https://firebase.google.com/support/privacy
              </a>
            </p>
          </section>

          {/* Section 6 - Use of Cookies */}
          <section id="section-6" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Use of Cookies</h2>
            <p className="mb-4">
              We value your privacy and treat data collected through cookies and similar technologies as non-personal information. A "cookie" is a small piece of data stored on your device by websites to help enhance your browsing experience. These cookies do not contain personal details such as your name, email address, or any other identifiable information. Instead, they are used to recognize your device and remember preferences or actions taken during your visit. You have the option to disable cookies at any time through your browser settings.
            </p>
            <p className="mb-2">Examples of Cookies we use:</p>
            <div className="ml-2 space-y-4">
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-1">Session Cookies</h3>
                <p>We use Session Cookies to operate our Service.</p>
              </div>
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-1">Preference Cookies</h3>
                <p>We use Preference Cookies to remember your preferences and various settings.</p>
              </div>
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-1">Security Cookies</h3>
                <p>We use Security Cookies for security purposes.</p>
              </div>
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-1">Advertising Cookies</h3>
                <p>Advertising Cookies are used to serve you with advertisements that may be relevant to you and your interests.</p>
              </div>
            </div>
          </section>

          {/* Section 7 - DPO */}
          <section id="section-7" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Data Protection Officer (DPO)</h2>
            <p className="mb-4">
              We have appointed a Data Protection Officer (DPO) to oversee our data protection strategy and ensure our app complies with privacy regulations. The DPO is responsible for:
            </p>
            <ul className="list-disc list-inside ml-4 space-y-1 mb-4">
              <li>Monitoring compliance with data protection laws.</li>
              <li>Acting as a point of contact for data protection-related inquiries.</li>
              <li>Assisting users in exercising their data protection rights.</li>
            </ul>
            <p className="mb-2">If you have any questions about your privacy or would like to exercise any of your rights under applicable laws, please contact our DPO.</p>
            <p className="mb-1 font-bold">Contact Information for the DPO:</p>
            <p>
              Email:{" "}
              <a href="mailto:mergeriosolutions@gmail.com" className="text-blue-600 hover:underline">
                mergeriosolutions@gmail.com
              </a>
            </p>
            <p>Contact No.: +91 8433400233</p>
          </section>

          {/* Section 8 - User Rights */}
          <section id="section-8" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Our User’s Rights and Opt-Out Choices</h2>
            <p className="mb-2">
              Depending on the laws in your jurisdiction, you may have several rights regarding your personal information and opt-out choices. These rights could include:
            </p>
            <ul className="list-disc list-inside ml-4 space-y-2 mb-4">
              <li>Access to Information: You can request information about the data we have collected about you.</li>
              <li>Manage Permissions: You may revoke any permissions you've previously granted, such as access to your camera or photo library.</li>
              <li>Data Deletion: Request the deletion of your personal information.</li>
              <li>
                Opt-Out: You can choose to opt out of the following-
                <ul className="list-disc list-inside ml-6 mt-1 space-y-2">
                  <li>
                    <strong>Targeted Advertising:</strong> Users can opt-out of personalized or targeted advertising by adjusting their device settings such as enabling “Opt out of Ads Personalization” in their device settings or through their advertising preferences.
                  </li>
                  <li>
                    <strong>Sale or Sharing of Personal Data:</strong> We do not sell users’ personal data. However, users may request that we stop sharing their personal information with third-party partners by contacting us at the email provided below.
                  </li>
                  <li>
                    <strong>Profiling or Automated Decision Making:</strong> Our apps do not use personal data for automated decision-making that produces legal or similarly significant effects.
                  </li>
                </ul>
              </li>
            </ul>
            <p className="mb-2 font-semibold">How to Exercise Your Rights</p>
            <p className="mb-4">
              Users may exercise their privacy rights, including requesting access, correction, deletion, or opting out of data sharing, by contacting us at:{" "}
              <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600 hover:underline">
                feedback@appspacesolutions.in
              </a>
              .
            </p>
            <p className="mb-4">
              We will respond to such requests in accordance with applicable data protection laws.
            </p>
            <p className="mb-6">
              California residents should refer to the "Users of California" section, users from Brazil should refer to "Users of Brazil," and EU users should consult the "EU Users" section for further details.
            </p>

            <h3 className="font-semibold text-xl text-gray-800 mb-2">Right to Lodge a Complaint</h3>
            <p className="mb-2">
              You have the right to lodge a complaint with a competent supervisory authority if you believe that your data protection rights have been violated.
            </p>
            <p className="mb-2">
              For users in the European Economic Area (EEA), you may contact your local data protection authority. A list of supervisory authorities is available through your country’s official data protection body.
            </p>
            <p className="mb-2">
              For users in other regions, you may contact your relevant regulatory authority or data protection authority in your jurisdiction.
            </p>
            <p>
              We encourage you to contact us first at{" "}
              <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600 hover:underline">
                feedback@appspacesolutions.in
              </a>
              , and we will do our best to address your concerns promptly and transparently.
            </p>
          </section>

          {/* Section 9 - California */}
          <section id="section-9" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Users of California</h2>
            <p className="mb-2">
              If you are a California resident, you have the following rights under the CCPA:
            </p>
            <ul className="list-disc list-inside ml-4 space-y-2 mb-4">
              <li><strong>Right to Know:</strong> You have the right to know what personal information we collect, use, and disclose, and for what purpose.</li>
              <li><strong>Right to Access:</strong> Request a copy of the personal information we have collected about you.</li>
              <li><strong>Right to Delete:</strong> Request deletion of your personal data, including disconnecting and removing any record of your Google Drive connection metadata that we hold.</li>
              <li><strong>Right to Correct:</strong> Request correction of inaccurate personal information we hold about you.</li>
              <li><strong>Right to Opt-Out of Sale/Sharing:</strong> We do not sell your personal information, and we do not sell or share information related to your connected Google Drive account.</li>
              <li><strong>Right to Limit Use of Sensitive Personal Information:</strong> We do not use your cloud storage connection data for any purpose beyond providing the file management feature you requested.</li>
            </ul>
            <p className="mb-4">
              Regarding the Google Drive feature specifically: we do not collect, store, or have access to the contents of files in your connected Google account. Any metadata used to display your files within the app (such as file names or folder structure) is processed only for as long as needed to complete your requested action and is not sold, shared for advertising, or retained on our servers afterward.
            </p>
            <p>
              To exercise any of these rights, contact us at{" "}
              <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600 hover:underline">
                feedback@appspacesolutions.in
              </a>
              . We will verify your request and respond within the timeframe required by law.
            </p>
          </section>

          {/* Section 10 - EU Users */}
          <section id="section-10" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">EU Users</h2>
            <p className="mb-2">
              For EU users, under the GDPR, you have the right to:
            </p>
            <ul className="list-disc list-inside ml-4 space-y-2 mb-4">
              <li><strong>Right to Access:</strong> Request access to your personal data and obtain a copy, including any connection metadata related to a linked Google Drive account.</li>
              <li><strong>Right to Rectification:</strong> Request correction of inaccurate personal data.</li>
              <li><strong>Right to Erasure:</strong> Request deletion of your personal data. Note that files stored in your own Google Drive account must be deleted directly through your Google account, since we do not hold copies of them.</li>
              <li><strong>Right to Restrict Processing:</strong> Request restriction of processing your personal data.</li>
              <li><strong>Right to Data Portability:</strong> Request transfer of your data to another organization.</li>
              <li><strong>Right to Object:</strong> Object to processing of your personal data.</li>
              <li><strong>Right to Withdraw Consent:</strong> Where our processing relies on your consent (such as connecting a Google account), you may withdraw it at any time by disconnecting the account in-app or via <a href="https://myaccount.google.com/permissions" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">myaccount.google.com/permissions</a>, without affecting the lawfulness of processing before withdrawal.</li>
            </ul>
            <p className="mb-4">
              <strong>Legal basis for the cloud storage feature:</strong> we process the limited connection data described above based on your consent (Art. 6(1)(a) GDPR), given when you choose to link your Google account. You may withdraw this consent at any time, which will stop any further processing but does not affect files already transferred before withdrawal.
            </p>
            <p className="mb-4">
              <strong>International transfers:</strong> since your files remain in your own Google Drive account, any international transfer of your file contents is governed by Google's own privacy policy and data processing terms, not by us.
            </p>
            <p>
              To exercise these rights, please contact us at{" "}
              <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600 hover:underline">
                feedback@appspacesolutions.in
              </a>
              . You also have the right to lodge a complaint with your local supervisory authority.
            </p>
          </section>

          {/* Section 11 - Brazil */}
          <section id="section-11" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Users of Brazil</h2>
            <p className="mb-2">
              If you are in Brazil, you have the following rights under the LGPD:
            </p>
            <ul className="list-disc list-inside ml-4 space-y-2 mb-4">
              <li><strong>Right to Confirmation:</strong> Confirm whether we process your personal data.</li>
              <li><strong>Right to Access:</strong> Access your personal data, including connection metadata related to a linked Google Drive account.</li>
              <li><strong>Right to Correction:</strong> Correct incomplete, inaccurate, or outdated data.</li>
              <li><strong>Right to Deletion:</strong> Request deletion of unnecessary or excessive data. Note that files in your own Google Drive account must be deleted through your Google account directly, as we do not retain copies of them.</li>
              <li><strong>Right to Data Portability:</strong> Request transfer of your data to another service provider.</li>
              <li><strong>Right to Opposition:</strong> Oppose the processing of your personal data in certain situations, including revoking the Google Drive connection at any time.</li>
              <li><strong>Right to Information About Sharing:</strong> Know which public and private entities we have shared your data with, and for what purpose. We do not share cloud storage connection data with anyone other than Google, as the provider you chose to connect.</li>
              <li><strong>Right to Revoke Consent:</strong> Where processing is based on consent (such as linking your Google account), you may revoke it at any time without affecting processing carried out before revocation.</li>
            </ul>
            <p className="mb-4">
              Regarding the Google Drive feature specifically: connecting your Google account does not give us custody of your files. They remain under your control in your own Google account. We only process the minimal connection data necessary to display and act on your files within the app, and this is not sold or shared for advertising purposes.
            </p>
            <p>
              To exercise these rights, please contact us at{" "}
              <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600 hover:underline">
                feedback@appspacesolutions.in
              </a>
              .
            </p>
          </section>

          {/* Section 12 - Virginia */}
          <section id="section-12" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Users of Virginia</h2>
            <p className="mb-2">
              If you are a resident of Virginia, you have the following rights under the Virginia Consumer Data Protection Act (VCDPA):
            </p>
            <ul className="list-disc list-inside ml-4 space-y-2 mb-4">
              <li><strong>Right to Confirm &amp; Access:</strong> You may confirm whether we process your personal data and request access to it.</li>
              <li><strong>Right to Correct:</strong> You may request correction of inaccurate personal data we hold about you.</li>
              <li><strong>Right to Delete:</strong> You may request deletion of personal data we hold about you, including any residual data related to a Google Drive connection (such as connection logs). Note that files stored in your own Google account must be deleted directly through your Google account, since we do not hold copies of them.</li>
              <li><strong>Right to Data Portability:</strong> You may request a copy of the personal data we hold about you, in a portable format, where applicable.</li>
              <li><strong>Right to Opt Out:</strong> You may opt out of targeted advertising, the sale of personal data, or profiling. We do not engage in any of these with respect to your cloud storage connection data.</li>
            </ul>
            <p className="mb-4">
              Regarding the Google Drive feature specifically: connecting your Google account does not give us ownership, custody, or a stored copy of your files. They remain under your control in your Google account at all times. You may revoke our access at any time via the app's settings or through{" "}
              <a href="https://myaccount.google.com/permissions" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                https://myaccount.google.com/permissions
              </a>
              .
            </p>
            <p>
              To exercise your rights, contact us at{" "}
              <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600 hover:underline">
                feedback@appspacesolutions.in
              </a>
              . We will respond in accordance with applicable law.
            </p>
          </section>

          {/* Section 13 - DMCA */}
          <section id="section-13" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">DMCA Copyright Policy</h2>
            <p className="mb-4">
              All Content available on the Platform is licensed from third-party services such as YouTube. All copyrights are owned by their respective owners and are used with permission. The Platform only provides outbound links to these Third-Party Services and has no direct control over their content. In compliance with the Digital Millennium Copyright Act, the Company has adopted the following general stance toward copyright infringement.
            </p>
            <p className="mb-4">
              YouTube Content: third-party content available through the use of Google’s API (such as text, images, videos, audio, or software) hosted by YouTube.
            </p>

            <h3 id="section-13-1" className="font-semibold text-xl text-gray-800 mb-2">Infringement policy</h3>
            <p className="mb-4">
              We respect the intellectual property rights of others and expect our users to do the same. If you believe that your copyrighted work or intellectual property has been used in a way that constitutes infringement within our app, please notify us immediately.
            </p>

            <h3 id="section-13-1-1" className="font-semibold text-xl text-gray-800 mb-2">How to Report Infringement</h3>
            <p className="mb-2">If you believe your rights have been violated, please provide us with the following information:</p>
            <ul className="list-disc list-inside ml-4 space-y-1 mb-4">
              <li>A description of the copyrighted or intellectual property that you claim has been infringed.</li>
              <li>A description of where the material in question is located within the app (such as a link or screenshot).</li>
              <li>Your contact information, including your name, email address, and phone number.</li>
              <li>A statement that you have a good faith belief that the use of the material is not authorized by the copyright owner, its agent, or the law.</li>
              <li>A statement that the information provided in the notification is accurate and that you are the copyright or intellectual property owner or authorized to act on behalf of the owner.</li>
            </ul>
            <p>
              To submit your infringement claim, please contact us at:{" "}
              <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600 hover:underline">
                feedback@appspacesolutions.in
              </a>
              .
            </p>
          </section>

          {/* Section 14 - In-app Advertisements */}
          <section id="section-14" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">In-app Advertisements</h2>
            <p className="mb-4">
              We reserve the right to place adverts on the platforms to maintain the free functionalities. These advertisements may be interspersed with other features, and some of those features may only be activated if you view the ads. If you choose to stop seeing certain adverts, you might lose access to those features or encounter other app restrictions.
            </p>
            <p>
              Your use of the App may be terminated if you use any method to get around any In-app advertisements.
            </p>
          </section>

          {/* Section 15 - In-app Purchases */}
          <section id="section-15" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">In-app Purchases</h2>
            <p className="mb-4">
              We offer you choices with in-app purchases to improve your user experience and let you explore and take advantage of more features across the platform.
            </p>
            <p className="mb-4">
              If you wish to make any purchase, you do so through the Google Play service and also agree to their respective Terms and Conditions.{" "}
              <a href="https://play.google.com/intl/en-us/about/play-terms/index.html" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                https://play.google.com/intl/en-us/about/play-terms/index.html
              </a>
            </p>
            <p>Also, it is to be noted that we’re not a party to any In-app purchases.</p>
          </section>

          {/* Section 16 - Liability Limitation */}
          <section id="section-16" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Liability Limitation</h2>
            <p className="mb-4">
              We shall in no event be liable for any loss or damage (incidental or consequential) of your device or files, including photos, videos, documents, and music, caused by-
            </p>
            <ul className="list-disc list-inside ml-4 space-y-1">
              <li>Access or inability to access the services offered in our apps.</li>
              <li>Any third party's conduct.</li>
              <li>Unauthorized or inappropriate use of the App in mobile applications other than what it was intended for.</li>
            </ul>
          </section>

          {/* Section 17 - Disclaimer of Warranty */}
          <section id="section-17" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Disclaimer of Warranty</h2>
            <p className="mb-4">
              Our services provided through mobile applications are provided “as is" and “as available,” with no warranties (expressed or implied). It also includes, but is not limited to, warranties of quality, marketability, fitness of services for particular purposes, or non-infringement.
            </p>
            <p>You use the App at your own risk and only as permitted by law.</p>
          </section>

          {/* Section 18 - Copyright and Trademarks */}
          <section id="section-18" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Copyright and Trademarks</h2>
            <p className="mb-4">
              Our apps give users the ability to create their own content. Photo editor &amp; Video editor - Merger IO will never claim ownership of your original work. You alone remain the sole person responsible for every piece of content you create, and therefore, you warrant it.
            </p>
            <p className="mb-4">
              We own and retain all rights to its content, applications, and services. Whereas our services and contents are protected by copyright, trademark, patent, trade secret, and other laws.
            </p>
            <p>
              We also reserve the right to use your feedback (without revealing any personal information about the person who provided it) as we see fit. Under no circumstances can the sender of any particular feedback claim ownership of it or ask for payment in return.
            </p>
          </section>

          {/* Section 19 - Push Notifications */}
          <section id="section-19" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Push Notifications</h2>
            <p className="mb-4">
              We provide you with the choice to receive push notifications to inform you of built-in features of the Application or any additional use of the Platform, or you can say enabling In-app notifications is an alternative. If you turn off notifications, you might not get information right away, and you can miss out on the latest updates and information.
            </p>
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Termination</h2>
            <p>
              Your access to any particular feature or the entire platform may be terminated if any violation is discovered in any way. The platform may be terminated with or without prior warning, and if, for any reason, you wish to do so, you may do so by deleting the application from your device.
            </p>
          </section>

          {/* Section 20 - Retention of data */}
          <section id="section-20" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Retention of data</h2>
            <p className="mb-4">
              We will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.
            </p>
            <p className="mb-4">
              We will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of our Service, or we are legally obligated to retain this data for longer periods.
            </p>
            <p>
              The files you store in your connected Google Drive account are retained according to your own settings in your Google account, not by us.
            </p>
          </section>

          {/* Section 21 - Data Recovery Policy */}
          <section id="section-21" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Data Recovery Policy</h2>
            <p className="mb-4">
              The app does not support Recoverable action after uninstallation of the app. If users are using the Hider functionality, then it is crucial to remember that you may lose all the trash or hidden data if you clear all your data or factory reset your device.
            </p>
            <p className="mb-4">
              To prevent your data from being lost, you may transfer the trash or hidden files from our app to your device because once you uninstall our app, you won't be able to recover those files. Our developers will not be liable for any of the private files or data.
            </p>
            <p>
              We prioritize your control over personalized data. You can easily manage and delete your local database, preferences, and logs directly from the app’s settings, without the need to visit any external service or URL. This includes clearing stored information in the local database, resetting your saved preferences, and deleting any logs generated during app usage, such as activity or error logs. All data management actions can be performed entirely within the app, giving you full control over your data without reliance on external platforms. We encourage users to regularly review and manage their data based on personal preferences.
            </p>
          </section>

          {/* Section 22 - Security of data */}
          <section id="section-22" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Security of data</h2>
            <p>
              The security of your data is important to us, but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
            </p>
          </section>

          {/* Section 23 - DO NOT TRACK */}
          <section id="section-23" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">OUR POLICY ON “DO NOT TRACK” SIGNALS UNDER THE CALIFORNIA ONLINE PROTECTION ACT (CALOPPA)</h2>
            <p className="mb-4">
              We do not support Do Not Track (“DNT”). Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked.
            </p>
            <p>
              You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.
            </p>
          </section>

          {/* Section 24 - Service Providers */}
          <section id="section-24" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Service Providers</h2>
            <p className="mb-4">
              We may employ third-party companies and individuals to facilitate our Service (“Service Providers”), provide the Service on our behalf, perform Service-related services, or assist us in analyzing how our Service is used. These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
            </p>
            <p className="mb-4">
              We also use the Google Drive API so that you can easily copy or transfer your files to Google Drive.
            </p>
            <p className="mb-2 font-medium">Check the following links for more details-</p>
            <p className="mb-1">
              Google API Services User Data Policy-{" "}
              <a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                https://developers.google.com/terms/api-services-user-data-policy
              </a>
            </p>
            <p>
              Google Privacy Policy-{" "}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                https://policies.google.com/privacy
              </a>
            </p>
          </section>

          {/* Section 24-1 - Disclaimer */}
          <section id="section-24-1" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">DISCLAIMER</h2>
            <p>
              ZX File Manager is not associated with any social media platform. Any unauthorized acts and/or violations of intellectual property rights are solely the user's responsibility. Before downloading and using the content, we suggest that you seek the permission of the owner.
            </p>
          </section>

          {/* Analytics */}
          <section id="section-24-1-1" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Analytics</h2>
            <p className="mb-4">
              To monitor and analyse the use of our service, we may use a third-party Service Provider. Analytics is limited to non-personal data.
            </p>

            <div className="ml-2 space-y-6">
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Facebook Analytics (by Facebook Inc.)</h3>
                <p className="mb-2">We use Facebook Analytics for in-game data analytics to improve our games.</p>
                <p>
                  For more information on the privacy practices of Facebook, please visit Facebook’s Data Policy:{" "}
                  <a href="https://www.facebook.com/privacy/explanation" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.facebook.com/privacy/explanation
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Firebase Analytics</h3>
                <p className="mb-2">
                  Google Firebase offers a variety of features, which can be found on the following summary page:{" "}
                  <a href="https://firebase.google.com/products/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://firebase.google.com/products/
                  </a>
                </p>
                <p className="mb-2">
                  The functions include the storage of apps, including users’ personal data, such as content they have created or information regarding their interaction with the apps. Google Firebase also offers interfaces that allow interaction between the users of the app and other services.
                </p>
                <p className="mb-2">
                  The analysis of user interactions is carried out using the analysis service of Firebase Analytics. This service helps us to record our users’ interactions. Events such as the first time an app is opened, the uninstalling of an app, updates, crashes, or the frequency of use of the app are recorded. Certain user interests are also recorded and evaluated.
                </p>
                <p className="mb-2">
                  The legal basis for use is Art. 6 paragraph 1 sentence 1 letter of GDPR. If users wish to object to interest-based advertising through Google marketing services, they can use{" "}
                  <a href="https://myadcenter.google.com/home?hl=en&sasb=true&ref=ad-settings" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://myadcenter.google.com/home?hl=en&sasb=true&ref=ad-settings
                  </a>
                </p>
                <p>
                  The information processed by Google Firebase may be used with other Google services, such as Google Analytics and Google marketing services. In this case, only pseudonymous information, such as the Android Advertising ID or the Advertising Identifier for iOS, will be processed to identify users’ mobile devices. Additional information on the use of data for marketing purposes by Google can be found on the summary page:{" "}
                  <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://policies.google.com/technologies/ads
                  </a>
                  . Google’s privacy policy is available at{" "}
                  <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://policies.google.com/privacy
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">GameAnalytics (by GameAnalytics)</h3>
                <p className="mb-2">We use GameAnalytics for in-game data analytics to improve our games.</p>
                <p>
                  For more information about GameAnalytics, please visit their Privacy Policy:{" "}
                  <a href="https://www.gameanalytics.com/trust/privacy-notice" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.gameanalytics.com/trust/privacy-notice
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Tenjin.io (by Tenjin, Inc.)</h3>
                <p className="mb-2">We use Tenjin for performance attribution.</p>
                <p>
                  For more information on what type of information Tenjin collects, please visit:{" "}
                  <a href="https://tenjin.com/privacy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://tenjin.com/privacy/
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Adjust (by Adjust GmbH.)</h3>
                <p className="mb-2">We use Adjust for performance attribution.</p>
                <p>
                  For more information on what type of information Adjust collects, please visit:{" "}
                  <a href="https://www.adjust.com/terms/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.adjust.com/terms/privacy-policy/
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">AppsFlyer (by AppsFlyer)</h3>
                <p className="mb-2">We use AppFlyer for performance attribution.</p>
                <p>
                  For more information on what type of information AppsFlyer collects, please visit:{" "}
                  <a href="https://www.appsflyer.com/legal/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.appsflyer.com/legal/privacy-policy/
                  </a>
                </p>
              </div>
            </div>
          </section>

          {/* Advertising */}
          <section id="section-24-1-2" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Advertising</h2>
            <p className="mb-4">
              We may use third-party Service Providers to show advertisements to you to help support and maintain our Service. Advertising is limited to non-personal data.
            </p>

            <div className="ml-2 space-y-6">
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">IronSource (by IronSource Mobile Ltd.)</h3>
                <p>
                  You can opt out of the IronSource network by following the instructions as described by IronSource on their Privacy Policy page. Check the link for more information-{" "}
                  <a href="https://developers.is.com/ironsource-mobile/air/ironsource-mobile-privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://developers.is.com/ironsource-mobile/air/ironsource-mobile-privacy-policy/
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">MoPub (Parent company- AppLovin)</h3>
                <p className="mb-2">
                  You can opt out of the MoPub service by following the instructions on the MoPub Opt-out page:{" "}
                  <a href="https://dash.applovin.com/p/how-applovin-shows-you-ads" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://dash.applovin.com/p/how-applovin-shows-you-ads
                  </a>
                </p>
                <p>
                  For more information on what information MoPub collects and how it is used, please read MoPub Privacy Policy:{" "}
                  <a href="https://www.applovin.com/privacy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.applovin.com/privacy/
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Facebook Audience Network (by Facebook Inc.)</h3>
                <p>
                  For more information about Facebook Audience Network, please visit their Policy:{" "}
                  <a href="https://developers.facebook.com/docs/audience-network/optimization/best-practices/an-policy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://developers.facebook.com/docs/audience-network/optimization/best-practices/an-policy/
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">AdMob (by Google Inc.)</h3>
                <p className="mb-2">
                  Understand how “the end-user data collected by Google Mobile Ads SDK” from the link below-{" "}
                  <a href="https://developers.google.com/admob/android/privacy/play-data-disclosure" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://developers.google.com/admob/android/privacy/play-data-disclosure
                  </a>
                </p>
                <p className="mb-2">
                  You can opt out from the AdMob by Google service by following the instructions described by Google:{" "}
                  <a href="https://support.google.com/My-Ad-Center-Help/answer/12155764?hl=en" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://support.google.com/My-Ad-Center-Help/answer/12155764?hl=en
                  </a>
                </p>
                <p>
                  For more information on how Google uses the collected information, please visit the “How Google uses data when you use our partners’ sites or app” page:{" "}
                  <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://policies.google.com/technologies/partner-sites
                  </a>{" "}
                  or visit the Privacy Policy of Google:{" "}
                  <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://policies.google.com/privacy
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">AppLovin (by AppLovin Corporation)</h3>
                <p className="mb-2">
                  If you’d like to opt out of AppLovin service, please visit the AppLovin Opt-out page:{" "}
                  <a href="https://dash.applovin.com/p/how-applovin-shows-you-ads" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://dash.applovin.com/p/how-applovin-shows-you-ads
                  </a>
                </p>
                <p>
                  If you’d like to learn more about AppLovin, please visit the Privacy Policy page of AppLovin:{" "}
                  <a href="https://www.applovin.com/privacy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.applovin.com/privacy/
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">HyprMx (by HyprMX Mobile LLC.)</h3>
                <p>
                  For more information about HyprMX, please visit their Privacy Policy:{" "}
                  <a href="https://jungroup.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://jungroup.com/privacy-policy
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Pangle (by Bytedance Pte.Ltd.)</h3>
                <p>
                  For more information about Pangle, please visit their Privacy Policy:{" "}
                  <a href="https://ad.oceanengine.com/union/media/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://ad.oceanengine.com/union/media/privacy
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Fyber (now Digital Turbine)</h3>
                <p>
                  For more information about Fyber, please visit their Privacy Policy:{" "}
                  <a href="https://www.digitalturbine.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.digitalturbine.com/legal/privacy-policy
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Vungle (by Vungle Inc.)</h3>
                <p className="mb-2">
                  You can opt out of Vungle service by following the instructions as described by Vungle on their Privacy Policy page:{" "}
                  <a href="https://vungle.com/privacy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://vungle.com/privacy/
                  </a>
                </p>
                <p>
                  For more information about Vungle, please visit their Privacy Policy:{" "}
                  <a href="https://vungle.com/privacy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://vungle.com/privacy/
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Mintegral (by Mintegral International Ltd.)</h3>
                <p>
                  For more information about Mintegral, please visit their Privacy Policy:{" "}
                  <a href="https://www.mintegral.com/en/privacy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.mintegral.com/en/privacy/
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Unity Ads (by Unity)</h3>
                <p>
                  For more information about Unity Ads, please visit their Privacy Policy:{" "}
                  <a href="https://unity.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://unity.com/legal/privacy-policy
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Ogury (by Ogury Limited)</h3>
                <p>
                  For more information about Ogury, please visit their Privacy Policy:{" "}
                  <a href="https://ogury.com/ogury-advertising-privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://ogury.com/ogury-advertising-privacy-policy/
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Tapjoy (by Tapjoy Inc.)</h3>
                <p className="mb-2">
                  You can opt-out of Tapjoy service by following the instructions as described by Tapjoy on their Privacy Policy page:{" "}
                  <a href="https://dev.tapjoy.com/en/legal/Advertiser-Terms-Of-Service" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://dev.tapjoy.com/en/legal/Advertiser-Terms-Of-Service
                  </a>
                </p>
                <p>
                  For more information about Tapjoy, please visit their Privacy Policy:{" "}
                  <a href="https://dev.tapjoy.com/en/legal/Privacy-Policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://dev.tapjoy.com/en/legal/Privacy-Policy
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Chartboost (by Chartboost Inc.)</h3>
                <p>
                  For more information about Chartboost, please visit their Privacy Policy:{" "}
                  <a href="https://docs.chartboost.com/en/legal/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://docs.chartboost.com/en/legal/privacy-policy/
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">AdColony (by Jirbo Inc.)</h3>
                <p className="mb-2">
                  You can opt out of AdColony service, check the link below for more information:{" "}
                  <a href="https://www.digitalturbine.com/legal/do-not-sell-or-share-my-personal-information-website" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.digitalturbine.com/legal/do-not-sell-or-share-my-personal-information-website
                  </a>
                </p>
                <p className="mb-2">
                  You can also opt out of AdColony through the Digital Advertising Alliance in the USA{" "}
                  <a href="https://optout.aboutads.info/?c=2&lang=EN" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://optout.aboutads.info/?c=2&lang=EN
                  </a>{" "}
                  or opt-out using your mobile device settings.
                </p>
                <p>
                  For more information about AdColony, please visit their Privacy Policy:{" "}
                  <a href="https://www.digitalturbine.com/legal/do-not-sell-or-share-my-personal-information-website" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.digitalturbine.com/legal/do-not-sell-or-share-my-personal-information-website
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">InMobi (by InMobi Pvt. Ltd.)</h3>
                <p className="mb-2">
                  You can opt out of the InMobi service by following the instructions as described on the InMobi Opt-out page:{" "}
                  <a href="https://advertising.inmobi.com/page/opt-out" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://advertising.inmobi.com/page/opt-out
                  </a>
                </p>
                <p>
                  For more information on the privacy practices and policies of InMobi, please visit the InMobi Privacy Policy:{" "}
                  <a href="https://advertising.inmobi.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://advertising.inmobi.com/privacy-policy
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Start.io (by Start.io Inc.)</h3>
                <p className="mb-2">
                  You can opt out of interest-based ads served by Start.io Inc. (formerly known as StartApp) by following the instructions on their Privacy Policy, section “8. Your Choices and Controls”:{" "}
                  <a href="https://www.start.io/policy/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.start.io/policy/privacy-policy/
                  </a>
                </p>
                <p>
                  For more information on what information Start.io collects and how it is used, please read their Privacy Policy:{" "}
                  <a href="https://www.start.io/policy/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.start.io/policy/privacy-policy/
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Smaato (by Smaato, Inc.)</h3>
                <p>
                  For more information on what information Smaato collects and how it is used, please read their Privacy Policy:{" "}
                  <a href="https://www.smaato.com/privacy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.smaato.com/privacy/
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Verizon (by Verizon Communications Inc.)</h3>
                <p>
                  For more information on what information Verizon collects and how it is used, please read their Privacy Policy:{" "}
                  <a href="https://www.verizon.com/about/privacy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.verizon.com/about/privacy/
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Google AdSense &amp; DoubleClick Cookie</h3>
                <p className="mb-2">
                  Google, as a third-party vendor, uses cookies to serve ads on our Service. Google’s use of the DoubleClick cookie enables it and its partners to serve ads to our users based on their visit to our Service or other websites on the Internet.
                </p>
                <p>
                  You may opt out of the use of the DoubleClick Cookie for interest-based advertising by visiting the Google Ads Settings web page:{" "}
                  <a href="https://myadcenter.google.com/home?hl=en&sasb=true&ref=ad-settings" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://myadcenter.google.com/home?hl=en&sasb=true&ref=ad-settings
                  </a>
                </p>
              </div>
            </div>
          </section>

          {/* Behavioral Remarketing */}
          <section id="section-24-1-3" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Behavioral Remarketing</h2>
            <p className="mb-4">
              The App uses remarketing services to advertise on third-party websites to you after you visit our Service. Our third-party vendors use cookies to inform, optimize, and serve ads based on your past visits to our Service.
            </p>

            <div className="ml-2 space-y-6">
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Google Ads</h3>
                <p className="mb-2">
                  Google AdWords remarketing service is provided by Google Inc.
                </p>
                <p className="mb-2">
                  You can opt out of Google Analytics for Display Advertising and customize the Google Display Network ads by visiting the Google Ads Settings page:{" "}
                  <a href="https://myadcenter.google.com/home?hl=en&sasb=true&ref=ad-settings" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://myadcenter.google.com/home?hl=en&sasb=true&ref=ad-settings
                  </a>
                </p>
                <p className="mb-2">
                  Google also recommends installing the Google Analytics Opt-out Browser Add-on –{" "}
                  <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://tools.google.com/dlpage/gaoptout
                  </a>{" "}
                  – for your web browser.
                </p>
                <p className="mb-2">
                  Google Analytics Opt-out Browser Add-on provides visitors with the ability to prevent their data from being collected and used by Google Analytics.
                </p>
                <p>
                  For more information on the privacy practices of Google, please visit the Google Privacy &amp; Terms web page:{" "}
                  <a href="https://policies.google.com/privacy?hl=en" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://policies.google.com/privacy?hl=en
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Facebook Ads</h3>
                <p className="mb-2">Facebook remarketing service is provided by Facebook Inc.</p>
                <p className="mb-2">
                  You can learn more about interest-based advertising from Facebook by visiting this page:{" "}
                  <a href="https://www.facebook.com/business/help/488043719226449?id=434838534925385" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.facebook.com/business/help/488043719226449?id=434838534925385
                  </a>
                </p>
                <p className="mb-2">
                  To opt out of Facebook’s interest-based ads, follow these instructions from Facebook:{" "}
                  <a href="https://www.facebook.com/help/568137493302217" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.facebook.com/help/568137493302217
                  </a>
                </p>
                <p className="mb-2">
                  Facebook adheres to the Self-Regulatory Principles for Online Behavioural Advertising established by the Digital Advertising Alliance. You can also opt-out from Facebook and other participating companies through the Digital Advertising Alliance in the USA{" "}
                  <a href="https://optout.aboutads.info/?c=2&lang=EN" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://optout.aboutads.info/?c=2&lang=EN
                  </a>
                  , the Digital Advertising Alliance of Canada in Canada{" "}
                  <a href="https://optout.aboutads.info/?c=2&lang=EN" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://optout.aboutads.info/?c=2&lang=EN
                  </a>{" "}
                  or the European Interactive Digital Advertising Alliance in Europe{" "}
                  <a href="http://www.youronlinechoices.eu/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    http://www.youronlinechoices.eu/
                  </a>
                  , or opt-out using your mobile device settings.
                </p>
                <p>
                  For more information on the privacy practices of Facebook, please visit Facebook’s Data Policy:{" "}
                  <a href="https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.facebook.com/privacy/policy/
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">AppLovin (by AppLovin Corporation)</h3>
                <p className="mb-2">
                  If you’d like to opt out of AppLovin service, please visit the AppLovin Opt-out page:{" "}
                  <a href="https://dash.applovin.com/p/how-applovin-shows-you-ads" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://dash.applovin.com/p/how-applovin-shows-you-ads
                  </a>
                </p>
                <p>
                  If you’d like to learn more about AppLovin, please visit the Privacy Policy page of AppLovin:{" "}
                  <a href="https://www.applovin.com/privacy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.applovin.com/privacy/
                  </a>
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Other Social Media Platforms</h3>
                <p className="mb-4">
                  We may use your information to send you marketing and promotional communications about our apps and services. This includes updates, special offers, and news related to our products. You may receive these communications through various channels, including email, push notifications, or in-app messaging.
                </p>
                <p className="mb-2">To promote our apps and engage with users, we also use a variety of social media platforms such as:</p>

                <div className="ml-4 space-y-3 text-base">
                  <div>
                    <p className="font-medium text-gray-800">Facebook -</p>
                    <p><a href="https://www.facebook.com/appspacesolutionss" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://www.facebook.com/appspacesolutionss</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">Instagram -</p>
                    <p><a href="https://www.instagram.com/appspaceoffical?igsh=c3Zsazh2bmlpMmxx" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://www.instagram.com/appspaceoffical</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">X (formerly Twitter) -</p>
                    <p><a href="https://twitter.com/AppSpaceSolu" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://twitter.com/AppSpaceSolu</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">LinkedIn -</p>
                    <p><a href="https://www.linkedin.com/company/appspace-solutions/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://www.linkedin.com/company/appspace-solutions/</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">YouTube -</p>
                    <p><a href="https://www.youtube.com/@appspacesolutions" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://www.youtube.com/@appspacesolutions</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">Pinterest -</p>
                    <p><a href="https://in.pinterest.com/appspacesolutions/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://in.pinterest.com/appspacesolutions/</a></p>
                  </div>
                  {/* <div>
                    <p className="font-medium text-gray-800">Discord -</p>
                    <p><a href="https://discord.gg/8ZTudM5d" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://discord.gg/8ZTudM5d</a></p>
                  </div> */}
                </div>

                <p className="mt-4 mb-2">
                  These platforms allow us to share updates, features, and promotional content, and interact with users who follow our accounts. Please note that while we use these platforms to advertise and promote our apps, we do not share your personal information with these social networks unless you specifically opt in or interact with our content directly on their platforms.
                </p>
                <p>
                  If you do not wish to receive marketing communications, you can opt out by following the unsubscribe instructions provided in any email or contacting us directly.
                </p>
              </div>
            </div>
          </section>

          {/* Section 25 - Payments */}
          <section id="section-25" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Payments</h2>
            <p className="mb-4">
              We may provide paid products and/or services within the Service. In that case, we use third-party services for payment processing (e.g., payment processors).
            </p>
            <p className="mb-4">
              We will not store or collect your payment card details. That information is provided directly to our third-party payment processors whose use of your personal information is governed by their Privacy Policy. These payment processors adhere to PCI DSS standards, managed by the PCI Security Standards Council, a joint effort of brands including Visa, Mastercard, American Express, and Discover. PCI-DSS requirements help ensure the secure handling of payment information.
            </p>
            <p className="mb-2">The payment processors we work with is:</p>
            <p className="mb-1 font-medium text-gray-800">Google Play In-App Payments</p>
            <p>
              Their Privacy Policy can be viewed at{" "}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                https://policies.google.com/privacy
              </a>
            </p>
          </section>

          {/* Section 26 - Links to other sites */}
          <section id="section-26" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Links to other sites</h2>
            <p>
              Our Service may contain links to other sites that are not operated by us. If you click a third-party link, you will be directed to that third-party's site. We strongly advise you to review the Privacy Policy of every site you visit. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
            </p>
          </section>

          {/* Section 27 - Children's Privacy */}
          <section id="section-27" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Children’s Privacy</h2>
            <p className="mb-4">
              ZX File Manager is designed for users who are 13 years of age or older (or the age specified by law in your country/region). If you are a guardian of a child under the age of 13 (or the legal age in your country/region), we encourage you to actively guide and supervise the child during their use of our products, ensuring the safety of their personal information.
            </p>
            <p>
              We advise child users under 13 (or the prescribed age in your country/region) to carefully read this policy with the assistance of a parent or guardian before using our services. All services or the provision of information should only be done with parental or guardian consent. If we discover that we have inadvertently collected personal information from a child, we will take swift action to delete the data.
            </p>
          </section>

          {/* Section 28 - Privacy Policy Changes */}
          <section id="section-28" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Privacy Policy Changes</h2>
            <p className="mb-4">
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. We will let you know via email and/or a prominent notice on our Service before the change becomes effective, and update the "effective date" at the top of this Privacy Policy.
            </p>
            <p>
              You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
            </p>
          </section>

          {/* Section 29 - Contact Us */}
          <section id="section-29" className="mt-12 mb-16">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">Contact Us</h2>
            <p>
              If you have any questions or suggestions, please contact us at{" "}
              <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600 hover:underline">
                feedback@appspacesolutions.in
              </a>
              . We are also open to your feedback.
            </p>
          </section>
        </div>
      </main>
    </>
  );
}